import React, { Component } from 'react';
import { AvGroup, AvInput } from 'availity-reactstrap-validation';
import { Label, Tooltip } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';
import { FRONT_END_URL } from '../../../../../utils/Constants';

class CategoryImage extends Component {
    renderImage() {
        const { label, figure } = styles;
        const { imagePreview, currentCategory } = this.props;
        let imageSrc;
        let labelStyle;
        let imgStyle;

        if (imagePreview !== null) {
            imageSrc = imagePreview;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 };
        } else if (currentCategory.imageUrl === null) {
            imageSrc = imagePreview;
            labelStyle = 'coloured-label'
            imgStyle = { height: '100%', objectFit: 'cover', zIndex: 1 };
        } else if (currentCategory.imageUrl) {
            imageSrc = `${FRONT_END_URL}/${currentCategory.imageUrl}`;
            labelStyle = '';
            imgStyle = { width: '100%', height: '100%', objectFit: 'cover', zIndex: 1 }
        }

        return (
            <AvGroup style={{ textAlign: 'center' }}>
                <Label>{i18n.t('screens:categoryScreen.categoryImage')}</Label>
                <div style={{ display: 'flex' }}>
                    <figure style={figure}>
                        <AvInput type="file" required={false} className="custom-file-input" name="imageUrl" id="imageUrl" onChange={(event) => this.props.uploadImage(event)} />
                        <label className={labelStyle} style={label} htmlFor="imageUrl">
                            <div style={{ display: 'flex', flexFlow: 'row wrap', justifyContent: 'center', flexDirection: 'column', textAlign: 'center' }}>
                                <span style={{ display: 'flex' }}><MaterialIcon icon="local_see" /> {i18n.t('screens:productScreen.uploadImage')}</span>

                                <div style={{ fontSize: 12 }}>{i18n.t('screens:categoryScreen.specifications')}</div>
                            </div>
                        </label>
                        <img style={imgStyle} src={imageSrc} />
                    </figure>
                    <div id='deleteCategoryImageButton' style={{ marginRight: 10, position: 'absolute', right: '20px' }} >
                        <span style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center' }} onClick={this.props.deleteCategoryImage}>
                            <MaterialIcon icon="delete_outline" color="#cdcdcd" size={26} />
                        </span>
                        {
                            this.props.includeTooltip ?
                                <Tooltip disabled={false} placement="top" isOpen={this.props.showDeleteImageTooltip} target="deleteCategoryImageButton" toggle={this.props.toggleDeleteImageTooltip}>
                                    {i18n.t('screens:productScreen.deleteImg')}
                                </Tooltip> : null
                        }
                    </div>
                </div>
            </AvGroup>
        )
    }

    render() {
        return this.renderImage();
    }
}

export default CategoryImage;

const styles = {
    label: {
        fontSize: 15,
    },

    figure: {
        display: 'flex',
        height: 250,
        width: 500,
        overflow: 'hidden',
        background: '#F8F8F8',
        marginBottom: 0
    },
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/additionalInformation/CategoryImage.js